import { ApiBaseService, ApiService } from './api.base.service';
import store from '@/store/store';
import { Site, SuccessResponse } from '@/types';
import Transformation from '../classes/transformation';

export interface SearchSiteResponse {
  sites: Site[];
  columnFilters: any;
  total: number;
}

export class SiteService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiService;
  }

  public async getSites(
    take: number = 0, skip: number = 0, sort: string = '',
    desc: boolean = false, filters: Record<string, Record<string, boolean>> = {},
    projectId: number | null = null, searchNames: string | null = null,
    includeColumnFilters: boolean = false,
  ): Promise<SearchSiteResponse> {
    const organisation = store.getters.activeOrganisation[0].id;

    let filtersString = '';

    const filterQuery = Transformation.filterMapToQueryString(filters);

    if (filterQuery) {
      filtersString += `&${filterQuery}`;
    }
    if (searchNames) {
      filtersString += `&searchNames=${searchNames}`;
    }
    return this.api.get(
      `organisation/${organisation}/` + (projectId ? `project/${projectId}/` : '') + 'sites?' +
      `take=${take}&skip=${skip}&sort=${sort}&desc=${desc}&includeColumnFilters=${includeColumnFilters}${filtersString}`);
  }

  public async getSite(id: number): Promise<Site> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.get(`organisation/${organisation}/site/${id}`);
  }

  public async createSite(details: any): Promise<Site> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${organisation}/site`, details);
  }

  public async createSites(sites: Site[]): Promise<Site[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.post(`organisation/${organisation}/sites`, sites);
  }

  public async deleteSite(site: Site): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.delete(`organisation/${organisation}/site/${site.id}`);
  }


  public async updateSite(id: number, payload: any): Promise<Site> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.api.put(`organisation/${organisation}/site/${id}`, payload);
  }

  public async getCoverage(site: Site | {lat: number, lng: number}): Promise< any | null > {
    const latitude = site.lat;
    const longitude = site.lng;

    const payload = {
      locations: [
        {
          lat: latitude,
          lng: longitude,
        },
      ],
      radius: 200,
    };

    const organisation = store.getters.activeOrganisation[0].id;
    const response = await this.api.post<any>(`organisation/${organisation}/network/sigfox-coverage`, payload, true);
    return response.data;
  }

  public async getCoverages(locations: Array<{lat: number, lng: number}>) {
    const locationsCopy = [...locations];
    const locationBatches: Array<Array<{lat: number, lng: number}>> = [];
    while (locationsCopy.length) {
      locationBatches.push(locationsCopy.splice(0, 200));
    }

    let coverageResults: any[] = [];
    const organisation = store.getters.activeOrganisation[0].id;
    for (const batch of locationBatches) {
      const response = await this.api.post<any>(`organisation/${organisation}/network/sigfox-coverage`, {locations: batch, radius: 200}, true);
      coverageResults = response.data.concat(coverageResults);
    }
    return coverageResults;
  }
}

export default new SiteService();
